import type { RouteRecordRaw } from 'vue-router';

export const fixedAssetsRoutes: RouteRecordRaw[] = [
  {
    path: 'fixed-assets',
    name: 'fixed-assets',
    component: () => import('./pages/FixedAssetsListPage.vue'),
    meta: { title: 'Fixed assets', requiresAuth: true, permission: 'view_fixed_assets' },
  },
  {
    path: 'fixed-assets/new',
    name: 'fixed-assets.create',
    component: () => import('./pages/FixedAssetFormPage.vue'),
    meta: { title: 'New fixed asset', requiresAuth: true },
  },
  {
    path: 'fixed-assets/:id',
    name: 'fixed-assets.show',
    component: () => import('./pages/FixedAssetDetailPage.vue'),
    meta: { title: 'Fixed asset', requiresAuth: true },
  },
  {
    path: 'fixed-assets/:id/edit',
    name: 'fixed-assets.edit',
    component: () => import('./pages/FixedAssetFormPage.vue'),
    meta: { title: 'Edit fixed asset', requiresAuth: true },
  },
  {
    path: 'reports/depreciation-schedule',
    name: 'reports.depreciation-schedule',
    component: () => import('./pages/DepreciationReportPage.vue'),
    meta: { title: 'Depreciation report', requiresAuth: true },
  },
];
